import { useState } from 'react'
import { useTranslation } from 'react-i18next'

import { Box, Button, Container, Paper, Typography } from '@mui/material'

import { useGetOrganizationsListQuery } from 'services/organizations'

import { TModalVariant } from 'components/Modal/types'
import OrganizationActionModal from 'components/OrganizationActionModal'
import OrganizationListItem from 'components/OrganizationListItem'
import Preloader from 'components/Preloader'

const Organizations = () => {
  const { t } = useTranslation()
  const [modalMode, setModalMode] = useState<TModalVariant>(null)
  const { data, isLoading, isFetching } = useGetOrganizationsListQuery()

  if (isLoading) return <Preloader />
  return (
    <>
      <Container maxWidth="lg" disableGutters>
        <Paper elevation={0} sx={{ p: 3 }}>
          <Typography variant="h1" mb={3}>
            {t('Pages.Organizations.MyOrganizations')}
          </Typography>
          <Box>
            {isFetching && <Preloader />}
            {data?.map((organization) => (
              <OrganizationListItem key={organization.id} organization={organization} />
            ))}
          </Box>
          <Button variant="contained" onClick={() => setModalMode('create')}>
            {t('Pages.Organizations.CreateOrganization')}
          </Button>
        </Paper>
      </Container>
      {modalMode && (
        <OrganizationActionModal variant={'create'} onClose={() => setModalMode(null)} />
      )}
    </>
  )
}

export default Organizations
